import React from 'react';
import { Container } from 'react-bootstrap';
import { Bar } from 'react-chartjs-2';

const BarChartAnalista = ({ count, countSpent, countReceipt, countAR }) => {
  let state;
  state = {
    dataBar: {
      labels: ['Verba', 'Gasto', 'Recebido', 'Custo'],
      datasets: [
        {
          label: '',
          data: [count, countSpent, countReceipt, countAR],
          backgroundColor: [
            'rgba(255, 134,159,0.4)',
            'rgba(98,  182, 239,0.4)',
            'rgba(255, 218, 128,0.4)',
            'rgba(170, 128, 252,0.4)',
            'rgba(255, 177, 101,0.4)'
          ],
          borderWidth: 2,
          borderColor: [
            'rgba(255, 134, 159, 1)',
            'rgba(98,  182, 239, 1)',
            'rgba(255, 218, 128, 1)',
            'rgba(170, 128, 252, 1)',
            'rgba(255, 177, 101, 1)'
          ]
        }
      ]
    },
    barChartOptions: {
      tooltips: {
        enabled: true,
        callbacks: {
          label: function(tooltipItem, data) {
            var value = data.datasets[0].data[tooltipItem.index];
            if (parseInt(value) >= 1000) {
              return value.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
              });
            } else {
              return value.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
              });
            }
          }
        }
      },
      legend: {
        display: false
      },
      responsive: true,
      maintainAspectRatio: true,
      scales: {
        xAxes: [
          {
            barPercentage: 1,
            gridLines: {
              display: true,
              color: 'rgba(0, 0, 0, 0.1)'
            }
          }
        ],
        yAxes: [
          {
            gridLines: {
              display: true,
              color: 'rgba(0, 0, 0, 0.1)'
            },
            ticks: {
              beginAtZero: true
            }
          }
        ]
      }
    }
  };

  return (
    <>
      <Container className="mt-2">
        <Bar
          data={state.dataBar}
          options={state.barChartOptions}
          height={210}
          style={{ position: 'fixed' }}
        />
      </Container>
    </>
  );
};
export default BarChartAnalista;
